import { useState } from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Download, CheckCircle, Loader2, Database } from 'lucide-react';
import { fetchAuditExport, fetchAuditIntegrity, fetchAuditStatus } from '../lib/api';

export default function AuditExportButton() {
  const [exporting, setExporting] = useState(false);
  const [lastExport, setLastExport] = useState<string | null>(null);
  const [integrity, setIntegrity] = useState<any>(null);
  const [status, setStatus] = useState<any>(null);

  const handleExport = async () => {
    setExporting(true);
    try {
      const [auditData, integrityData, statusData] = await Promise.all([
        fetchAuditExport(200),
        fetchAuditIntegrity(),
        fetchAuditStatus()
      ]);

      setIntegrity(integrityData);
      setStatus(statusData);

      // Download as JSON file
      const blob = new Blob([JSON.stringify({
        exportedAt: new Date().toISOString(),
        integrity: integrityData,
        persistence: statusData?.auditStore,
        events: auditData
      }, null, 2)], { type: 'application/json' });

      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `agentomy-audit-trail-${new Date().toISOString().split('T')[0]}.json`;
      a.click();
      URL.revokeObjectURL(url);

      setLastExport(new Date().toISOString());
    } catch (e) {
      console.error('Audit export failed:', e);
    }
    setExporting(false);
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Button
          onClick={handleExport}
          disabled={exporting}
          size="sm"
          className="bg-cyan-700 hover:bg-cyan-600 text-white text-xs"
        >
          {exporting ? (
            <><Loader2 className="w-3 h-3 mr-1 animate-spin" /> Exporting...</>
          ) : (
            <><Download className="w-3 h-3 mr-1" /> Export Audit Trail</>
          )}
        </Button>

        {status?.auditStore?.connected && (
          <Badge variant="outline" className="text-[10px] border-ag-active text-ag-active">
            <Database className="w-2.5 h-2.5 mr-0.5" /> persistent
          </Badge>
        )}
      </div>

      {lastExport && (
        <div className="flex items-center gap-1.5 text-xs text-gray-500">
          <CheckCircle className="w-3 h-3 text-ag-active" />
          Exported at {new Date(lastExport).toLocaleTimeString()}
          {integrity?.valid !== undefined && (
            <Badge variant="outline" className={`text-[10px] ml-1 ${
              integrity.valid ? 'border-ag-active text-ag-active' : 'border-ag-critical text-ag-critical'
            }`}>
              chain: {integrity.valid ? 'verified' : 'broken'}
            </Badge>
          )}
        </div>
      )}
    </div>
  );
}
